<template>
    <div class="p-5 pt-3">
        <h1 class="text-lg font-semibold mb-3">Leads</span>
            <v-chip
                    class="ma-2"
                    color="#44468F"
                    outlined
                    small
            >
                {{ messages.length }}
            </v-chip>
        </h1>
        <hr class="border-b border-gray-100 mb-3">

        <template>
            <div class="dashboard-box">
                <v-card class="pa-2" tile>
                    <v-skeleton-loader v-if="loading" type="article, article, article"></v-skeleton-loader>

                    <div v-if="!loading" class="p-3">
                        <div v-if="messages.length == 0">
                            <br/><br/><br/><br/>
                            <div class="dashboard-box-iconsquare">
                                <div class="dashboard-box-icon-background"></div>
                                <div class="dashboard-box-icon">
                                    <i class="mdi mdi-phone"></i>
                                </div>
                            </div>
                            <div style="text-align: center;">
                                <div class="pt-2 pb-2">
                                    <strong>No Leads</strong>
                                </div>

                                <div class="text-sm mb-4 text-gray-600">
                                    No leads found for the given period. Refine your search or wait until new leads come in.
                                </div>
                                <br/>
                            </div>
                            <br/><br/><br/><br/><br/>
                        </div>

                        <div v-else style="clear: both; padding-top: 0px;">

                            <v-data-table
                                :headers="headers"
                                :items="messages"
                                class="rg-datatable elevation-1"
                                mobile-breakpoint="10"
                                v-model="selected"
                                item-key="id"
                                disable-pagination
                                hide-default-footer
                            >
                            
                                <template v-slot:item.customer_phone_number="{ item }">
                                    <span :style="((item.archived == 1) ? 'text-decoration: line-through;' : '')"><a href="javascript: void(0);" @click="filterBy(item.customer_phone_number)">{{ item.customer_phone_number }}</a></span>
                                </template>
                            
                                <template v-slot:item.to="{ item }">
                                    {{ item.to || "-" }}
                                </template>

                                <template v-slot:item.lead_type="{ item }">
                                    <!-- <span v-if="item.sources.indexOf('web') != -1">
                                        Chat
                                    </span>
                                    <span v-else> -->
                                        <span v-if="item.lead_type == 'PHONE_CALL'">
                                            Voice
                                        </span>

                                        <span v-if="item.lead_type == 'MESSAGE'">
                                            Message
                                        </span>

                                        <span v-if="item.lead_type == 'BOOKING'">
                                            Booking
                                        </span>
                                    <!-- </span> -->
                                </template>

                                <template v-slot:item.lead_category="{ item }">
                                    <span v-if="item.lead_category">
                                        {{ item.lead_category.replace(/\_/g, " ") }}
                                    </span>

                                    <span v-if="!item.lead_category">
                                        N/A
                                    </span>
                                </template>

                                <template v-slot:item.sources="{ item }">
                                    <span v-if="item.sources.indexOf('lsa') != -1">
                                        <v-tooltip top color="primary">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <div v-if="item.lead_type == 'PHONE_CALL'" style="float: left; margin-right: 5px; padding-top: 4px; cursor: pointer;" @click="showLsaCallRecordings(item);"
                                                    >
                                                        <img :src="require('@/assets/images/lsa.webp')"
                                                            v-bind="attrs"
                                                            v-on="on" style="width: 26px;" />
                                                    </div>
                                                    <div v-if="item.lead_type == 'MESSAGE'" style="float: left; margin-right: 5px; padding-top: 4px; cursor: pointer;" @click="showLsaMessagesFunction(item);"
                                                    >
                                                        <img :src="require('@/assets/images/lsa.webp')"
                                                            v-bind="attrs"
                                                            v-on="on" style="width: 26px;" />
                                                    </div>
                                                </template>
                                                <span>LSA</span>
                                        </v-tooltip>
                                    </span>

                                    <span v-if="item.sources.indexOf('callrail') != -1">
                                        <v-tooltip top color="primary">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <div style="float: left; margin-right: 5px; padding-top: 4px; cursor: pointer;" @click="showCallRailRecordingFunction(item);"
                                                    >
                                                        <img :src="require('@/assets/images/callrail.png')"
                                                            v-bind="attrs"
                                                            v-on="on" style="width: 22px;" />
                                                    </div>
                                                </template>
                                                <span>CallRail</span>
                                        </v-tooltip>
                                    </span>

                                    <span v-if="item.sources.indexOf('bland') != -1">
                                        <v-tooltip bottom color="primary">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <div :id="'sblrcfncc-' + item.id" style="float: left; margin-right: 5px; padding-top: 4px; cursor: pointer;" @click="showBlandRecordingFunction(item);"
                                                    >
                                                        <img :src="require('@/assets/images/bland.png')"
                                                            v-bind="attrs"
                                                            v-on="on" style="width: 22px;" />
                                                    </div>
                                                </template>

                                                <span v-if="item.lead_type == 'MESSAGE'">AI</span>
                                                <span v-else>
                                                    <span>Details:</span>

                                                    <br /><br />
                                                    <strong>Customer's name:</strong> {{ item.customer_name || "-" }}
                                                    <br />
                                                    <strong>Customer's email:</strong> {{ item.customer_email || "-" }}
                                                    <br />
                                                    <strong>Customer's phone:</strong> {{ item.ai_provided_phone_number || "-" }}
                                                    <br />
                                                    <strong>Service needed:</strong> {{ item.job_type || "-" }}
                                                    <br /><br />
                                                    <strong>Call ended by:</strong> {{ item.call_ended_by || "-" }}
                                                </span>
                                        </v-tooltip>
                                    </span>

                                    <span v-if="item.sources.indexOf('web') != -1">
                                        <v-tooltip top color="primary">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <div style="float: left; margin-right: 5px; padding-top: 4px; cursor: pointer;" @click="showChatConversation(item);"
                                                    >
                                                        <img :src="require('@/assets/images/web.png')"
                                                            v-bind="attrs"
                                                            v-on="on" style="height: 22px; border: solid 1px #dddddd;" />
                                                    </div>
                                                </template>
                                                <span>Web</span>
                                        </v-tooltip>
                                    </span>
                                </template>

                                <template v-slot:item.ai_feedback="{ item }">
                                    <div style="position: relative;">
                                        <a href="javascript: void(0);" @click="item.show_ai_feedback = !item.show_ai_feedback || true;">
                                            <span v-if="item.ai_feedback_urgent">🚨</span>
                                            <strong v-if="item.ai_feedback">View</strong><span v-else="">Edit</span>
                                        </a>

                                        <div v-show="item.show_ai_feedback" style="position: absolute; background: #FFFFFF; padding: 10px; border: solid 1px #CCCCCC; width: 250px; z-index: 1;">
                                            <textarea v-model="item.ai_feedback" style="padding: 10px; width: 100%; height: 200px; border: solid 1px #CCCCCC; border-radius: 5px;"></textarea>

                                            <br />

                                            <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="item.ai_feedback_urgent" label="Urgent"></v-switch>

                                            <br />

                                            <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 w-full mb-2" :class="{'spinner': savingAiFeedback}" @click="saveAiFeedback(item)">
                                                SAVE
                                            </button>

                                            <button class="rounded custom-bordered-button hover:bg-gray-200 text-gray-800 border border-gray-800 focus:outline-none py-2 px-4 w-full mb-2" :class="{'spinner': savingAiFeedback}" @click="item.ai_feedback = ''; item.ai_feedback_urgent = 0; saveAiFeedback(item)">
                                                CLEAR
                                            </button>
                                        </div>
                                    </div>
                                </template>

                                <template v-slot:item.lead_creation_date="{ item }">
                                    {{ displayTimestamp(item.lead_creation_date) }}
                                </template>

                                <template v-slot:item.updated_at="{ item }">
                                    {{ displayTimestamp(item.updated_at) }}
                                </template>

                                <template v-slot:item.responded_time="{ item }">
                                    <span v-if="item.responded_time !== NULL && item.responded_time !== -1">
                                        <span v-if="item.responded_time > 1000">
                                            {{ parseInt(item.responded_time / 60) }} minutes
                                        </span>
                                        <span v-else>
                                            {{ item.responded_time }} seconds
                                        </span>
                                    </span>
                                    <span v-else>N/A</span>
                                </template>
                                
                                <template v-slot:item.geo="{ item }">
                                    <span v-if="item.geo">
                                        {{ item.geo.split(',')[0] }}
                                    </span>
                                    <span v-else>
                                        N/A
                                    </span>
                                </template>

                                <template v-slot:item.job_type="{ item }">
                                    <span v-if="item.job_type">
                                        {{ item.job_type.replace(/\_/g, " ").toLowerCase().replace(/\b[a-z]/g, function(letter) { return letter.toUpperCase(); }) }}
                                    </span>
                                    <span v-else>
                                        N/A
                                    </span>
                                </template>

                                <template v-slot:item.call_status="{ item }">
                                    <span v-if="item.call_status == 'in-progress'">
                                        <i class="fa fa-spin fa-spinner"></i>
                                    </span>
                                    <span v-else>
                                        {{ item.call_status }}
                                    </span>
                                </template>

                                <template v-slot:item.from="{ item }">
                                    {{ formatPhoneNumber(item.from) }}
                                </template>

                                <template v-slot:item.recording_url="{ item }">
                                    <div v-if="item.recording_url">
                                        <i class="audio-element-icon fa fa-play" :id="'audio-element-icon-' + item.id" style="cursor: pointer;" @click="playAudio(item);"></i>

                                        <div class="audio-element-wrapper" :id="'audio-element-wrapper-' + item.id" style="position: absolute; z-index: 99; margin-left: -10px; display: none !important; margin-top: -20px;">
                                            <i class="mdi mdi-close-circle" style="position: absolute; right: 0px; top: -10px; font-size: 20px; z-index: 99; cursor: pointer;" @click="playAudio(item)"></i>
                                            <audio class="audio-element" :id="'audio-element-' + item.id" controls="play, pause, volume" style="height: 38px;">
                                                <source :src="item.recording_url" type="audio/mpeg">
                                            </audio>
                                        </div>
                                    </div>
                                    <div v-else>
                                        -
                                    </div>
                                </template>

                                <template v-slot:item.customer_name="{ item }">
                                    <div :class="'lsa-show-customer-name lsa-show-customer-name-' + item.id">
                                        <a href="javascript: void(0);" @click="showEditCustomerName(item)">{{ item.customer_name }}<i v-show="$store.state.auth.owner" class="mdi mdi-pencil-outline ml-2"></i></a>
                                    </div>
                                    <div :class="'lsa-edit-customer-name lsa-edit-customer-name-' + item.id" style="display: none; position: relative;">
                                        <input type="text" :value="item.customer_name" style="padding: 5px; border: solid 1px #CCCCCC; width: 100px;" />
                                        <div style="position: absolute; margin-top: -22px; right: -31px;">
                                            <a href="javascript: void(0);" style="color: #3EBB80 !important;" @click="editCustomerName(item)"><i class="mdi mdi-check"></i></a>
                                            <a href="javascript: void(0);" class="" style="color: #E53F71 !important;" @click="cancelEditCustomerName(item)"><i class="mdi mdi-close"></i></a>
                                        </div>
                                        <div style="clear: both;"></div>
                                    </div>
                                </template>

                                <template v-slot:item.address="{ item }">
                                    <div :class="'lsa-show-address lsa-show-address-' + item.id">
                                        <a href="javascript: void(0);" @click="showEditAddress(item)">{{ item.address }}<i v-show="$store.state.auth.owner" class="mdi mdi-pencil-outline ml-2"></i></a>
                                    </div>
                                    <div :class="'lsa-edit-address lsa-edit-address-' + item.id" style="display: none; position: relative;">
                                        <input type="text" :value="item.address" style="padding: 5px; border: solid 1px #CCCCCC; width: 100px;" />
                                        <div style="position: absolute; margin-top: -22px; right: -31px;">
                                            <a href="javascript: void(0);" style="color: #3EBB80 !important;" @click="editAddress(item)"><i class="mdi mdi-check"></i></a>
                                            <a href="javascript: void(0);" class="" style="color: #E53F71 !important;" @click="cancelEditAddress(item)"><i class="mdi mdi-close"></i></a>
                                        </div>
                                        <div style="clear: both;"></div>
                                    </div>
                                </template>

                                <template v-slot:item.value="{ item }">
                                    <div :class="'lsa-show-value lsa-show-value-' + item.id">
                                        <a href="javascript: void(0);">${{ item.value }}<i v-show="$store.state.auth.owner" class="mdi mdi-pencil-outline ml-2"></i></a>
                                    </div>
                                </template>

                                <template v-slot:item.tag="{ item }">
                                    <div class="pt-2 pb-2">
                                        <span v-for="(tag, index_tag) in item.tag" :key="'tag-' + index_tag" class="pr-2 pb-2">
                                            <v-chip v-if="tag == 0" class="mb-1 dark">
                                                <span style="font-size: 12px;">Not Set</span>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 1" color="#3EBB80">
                                                <span style="font-size: 12px; color: #FFFFFF;">Existing Customer</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 2" color="#44468F">
                                                <span style="font-size: 12px; color: #FFFFFF;">Missed Call</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 3" color="#FFB443" v-show="!isOnlyAi()">
                                                <span style="font-size: 12px; color: #FFFFFF;">Opportunity</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 4" color="#2477F6" v-show="!isOnlyAi()">
                                                <span style="font-size: 12px; color: #FFFFFF;">Meeting Scheduled</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 5" color="#E53F71">
                                                <span style="font-size: 12px; color: #FFFFFF;">Became Customer</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 'Signed'" color="#2137cb" v-show="!isOnlyAi()">
                                                <span style="font-size: 12px; color: #FFFFFF;">Signed</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 'Booked for Consultation'" color="#2bce7f" v-show="!isOnlyAi()">
                                                <span style="font-size: 12px; color: #FFFFFF;">Booked for Consultation</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 'Declined/Not a lead'" color="#aa242b" v-show="!isOnlyAi()">
                                                <span style="font-size: 12px; color: #FFFFFF;">Declined/Not a lead</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 'Wrong Number'" color="#de2f4d" v-show="!isOnlyAi()">
                                                <span style="font-size: 12px; color: #FFFFFF;">Wrong Number</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 'No Response'" color="#3f3f3f" v-show="!isOnlyAi()">
                                                <span style="font-size: 12px; color: #FFFFFF;">No Response</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 'Existing Client'" color="#4ad25a" v-show="!isOnlyAi()">
                                                <span style="font-size: 12px; color: #FFFFFF;">Existing Client</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 'Failed Sign Up'" color="#830934" v-show="!isOnlyAi()">
                                                <span style="font-size: 12px; color: #FFFFFF;">Failed Sign Up</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 'Following Up/Working on this one'" color="#9418af" v-show="!isOnlyAi()">
                                                <span style="font-size: 12px; color: #FFFFFF;">Following Up/Working on this one</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 'E-Doc sent not signed'" color="#5a3a69" v-show="!isOnlyAi()">
                                                <span style="font-size: 12px; color: #FFFFFF;">E-Doc sent not signed</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 'Booked to Service'" color="#2bce7f" v-show="!isOnlyAi()">
                                                <span style="font-size: 12px; color: #FFFFFF;">Booked to Service</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 'Booked for Appointment'" color="#1921ba" v-show="!isOnlyAi()">
                                                <span style="font-size: 12px; color: #FFFFFF;">Booked for Appointment</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 'Cancelled'" color="#c6ab24">
                                                <span style="font-size: 12px; color: #FFFFFF;">Cancelled</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 'Complete'" color="#1921ba">
                                                <span style="font-size: 12px; color: #FFFFFF;">Complete</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 'Incomplete'" color="#c6ab24">
                                                <span style="font-size: 12px; color: #FFFFFF;">Incomplete</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 'AI Test Call'" color="#000000">
                                                <span style="font-size: 12px; color: #FFFFFF;">AI Test Call</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag == 'Duplicate Call'" color="#6750D7">
                                                <span style="font-size: 12px; color: #FFFFFF;">Duplicate Call</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>

                                            <v-chip class="mb-1" v-if="tag != 0 && tag != 1 && tag != 2 && tag != 3 && tag != 4 && tag != 5
                                                && tag != 'Signed'
                                                && tag != 'Booked for Consultation'
                                                && tag != 'Declined/Not a lead'
                                                && tag != 'Wrong Number'
                                                && tag != 'No Response'
                                                && tag != 'Existing Client'
                                                && tag != 'Failed Sign Up'
                                                && tag != 'Following Up/Working on this one'
                                                && tag != 'E-Doc sent not signed'
                                                && tag != 'Booked to Service'
                                                && tag != 'Booked for Appointment'
                                                && tag != 'Cancelled'
                                                && tag != 'Complete'
                                                && tag != 'Incomplete'
                                                && tag != 'AI Test Call'
                                                && tag != 'Duplicate Call'
                                            
                                            " :color="getCustomTagColor(tag)">
                                                <span style="font-size: 12px; color: #FFFFFF;">{{ tag }}</span>

                                                <v-icon v-show="$store.state.auth.owner" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                            </v-chip>
                                        </span>
                                    </div>
                                </template>

                                <template v-slot:item.qualify_status="{ item }">
                                    <v-chip
                                            small
                                            color="gray lighten-5"
                                            text-color="gray lighten-1"
                                        
                                            v-if="item.qualify_status == 0"
                                    >
                                        Not Set
                                    </v-chip>

                                    <v-chip
                                            small
                                            color="green lighten-5"
                                            text-color="green lighten-1"
                                        
                                            v-if="item.qualify_status == 1"
                                    >
                                        Qualified
                                    </v-chip>

                                    <v-chip
                                            small
                                            color="red lighten-5"
                                            text-color="red lighten-1"
                                        
                                            v-if="item.qualify_status == -1"
                                    >
                                        Unqualified
                                    </v-chip>

                                    <v-chip
                                            small
                                            color="red darken-2"
                                            text-color="white"
                                        
                                            v-if="item.qualify_status == 2"
                                    >
                                        Spam
                                    </v-chip>

                                    <v-chip v-if="item.qualify_status != 0 && item.qualify_status != 1 && item.qualify_status != 2 && item.qualify_status != -1" :color="getCustomStatusColor(item.qualify_status)"
                                        small
                                        text-color="white"
                                    >
                                        {{ item.qualify_status }}
                                    </v-chip>
                                </template>

                                <template v-slot:item.id="{ item }">

                                    <div style="position: relative;">

                                        <a href="javascript: void(0);" @click="notes_lead = item; show_notes_dialog = true"><i class="mdi mdi-comment-multiple-outline" style="font-size: 16px;"></i></a>

                                        <span v-if="item.notes.length > 0" style="width: 16px;
                                            height: 16px;
                                            line-height: 17px;
                                            font-size: 10px;
                                            background: rgb(255, 112, 67);
                                            color: rgb(255, 255, 255);
                                            padding: 0px !important;
                                            border-radius: 100%;
                                            position: absolute;
                                            font-weight: 600;
                                            text-align: center;
                                            margin-top: -3px;
                                            margin-left: -6px;">{{ item.notes.length }}</span>

                                        &nbsp; &nbsp;

                                        <v-menu
                                                bottom
                                                right

                                                nudge-bottom='25'
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon color="green" v-bind="attrs" v-on="on" :ripple="false" small class="ml-1">mdi-dots-vertical</v-icon>
                                            </template>

                                            <v-list class="table-menu-actions">
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title v-show="item.archived == 0"><a href="javascript: void(0);" @click="archiveLead(item)"><span
                                                        class="table-menu-action-icon"><i
                                                        class="mdi mdi-archive-outline"></i></span> Archive</a>
                                                    </v-list-item-title>
                                                    <v-list-item-title v-show="item.archived == 1"><a href="javascript: void(0);" @click="unArchiveLead(item)"><span
                                                        class="table-menu-action-icon"><i
                                                        class="mdi mdi-package-up"></i></span> Unarchive</a>
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </div>
                                </template>
                            </v-data-table>
                        </div>
                    </div>
                </v-card>
            </div>
        </template>
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios'
import moment from 'moment'

export default {
    data() {
        return {
            messages: [],
            loading: true,

            headers: [
                { text: 'Phone Number', value: 'customer_phone_number' },
                { text: 'AI Number', value: 'to' },
                { text: 'Lead Type', value: 'lead_type', width: 120 },
                { text: 'Business Category', value: 'lead_category' },
                { text: 'Sources', value: 'sources', width: 120 },
                { text: 'AI Feedback', value: 'ai_feedback', width: 140 },
                { text: 'Creation Date', value: 'lead_creation_date', width: 200 },
                { text: 'Last Updated', value: 'updated_at', width: 200 },
                { text: 'Response Time', value: 'responded_time' },
                { text: 'Location', value: 'geo' },
                { text: 'Job Type', value: 'job_type' },
                { text: 'Charge Status', value: 'charge_status' },
                { text: 'Dispute Status', value: 'dispute_status' },
                { text: 'Value', value: 'value' },
                { text: 'Tags', value: 'tag' },
                { text: 'Status', value: 'qualify_status' },
                { text: '', value: 'id' }
            ],
            
        }
    },

    methods: {
        getHost() {
        return window.location.host;
        },

        isOnlyAi() {
            return !this.isAccelerate();
        },

        isAccelerate() {
            //  || this.getHost() == 'zany-space-palm-tree-q9vjg4xr39j97-8080.app.github.dev'
            return this.getHost() == 'lsa.accelerateyourmarketing.com';
        },

        getCustomTagColor(tag) {
            for (var i in this.custom_tags) {
                if (this.custom_tags[i].tag == tag)
                    return this.custom_tags[i].color;
            }

            return "";  
        },

        getCustomStatusColor(status) {
            for (var i in this.custom_statuses) {
                if (this.custom_statuses[i].status == status)
                    return this.custom_statuses[i].color;
            }

            return "";  
        },

        formatDate: function(date, format = "MM/DD/YYYY") {
            return moment(String(date)).format(format)
        },

        displayTimestamp(date) {
            let timezone = "America/New_York";

            // .tz(timezone)
            return moment.utc(date).format('ddd M/D YYYY h:mm:ss A');
        },

        displayDuration(seconds) {
            return date;
        },

        displayDuration(time) {
            var sec_num = time // don't forget the second param
            var hours   = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours   < 10) {hours   = "0"+hours;}
            if (minutes < 10) {minutes = "0"+minutes;}
            if (seconds < 10) {seconds = "0"+seconds;}
            return hours+':'+minutes+':'+seconds;
        },

        formatPhoneNumber(phoneNumberString) {
            const match = phoneNumberString
    .replace(/\D+/g, '').replace(/^1/, '')
    .match(/([^\d]*\d[^\d]*){1,10}$/)[0]
    const part1 = match.length > 2 ? `(${match.substring(0,3)})` : match
    const part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : ''
    const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : ''    
    return `${part1}${part2}${part3}`
        },

        playAudio(item) {
            if (document.getElementById('audio-element-wrapper-' + item.id).style.display == 'none') {
                let elements = document.getElementsByClassName('audio-element-wrapper');

                for (var i in elements) {
                    try {
                        elements[i].style.display = 'none';
                    }
                    catch (e) {}
                }

                let elements2 = document.getElementsByClassName('audio-element');

                for (var i in elements) {
                    try {
                        elements2[i].pause();
                        elements2[i].currentTime = 0;
                    }
                    catch (e) {}
                }

                let elements3 = document.getElementsByClassName('audio-element-icon');

                for (var i in elements) {
                    try {
                        elements3[i].style.display = 'block';
                    }
                    catch (e) {}
                }

                document.getElementById('audio-element-wrapper-' + item.id).style.display = 'block';
                document.getElementById('audio-element-' + item.id).play();

                document.getElementById('audio-element-icon-' + item.id).style.display = 'none';

                
            }
            else {
                document.getElementById('audio-element-wrapper-' + item.id).style.display = 'none';
                document.getElementById('audio-element-' + item.id).pause();
                document.getElementById('audio-element-' + item.id).currentTime = 0;

                document.getElementById('audio-element-icon-' + item.id).style.display = 'block';
            }
        },

        async getMessages(silent = false) {
            let self = this;

            if (!silent)
                this.loading = true;

            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-messages`, {
                date_filter: this.date_filter,
                search: this.search,
                tag: this.tag,
                qualify_status: this.qualify_status,
                archived_filter: this.archived_filter,
                for_report: 1
            }, {
                headers: {
                    'RG-Auth-Loc-Uu': this.$route.params.uuid
                }
            })

            this.messages = response.data.messages;
            this.lsa_leads_count = response.data.lsa_leads_count;
            this.ai_leads_count = response.data.ai_leads_count;
            this.ai_leads_count_msg = response.data.ai_leads_count_msg;
            this.ai_leads_count_voice = response.data.ai_leads_count_voice;
            this.callrail_leads_count = response.data.callrail_leads_count;
            this.converted_leads_count = response.data.converted_leads_count;
            this.converted_ai_leads_count = response.data.converted_ai_leads_count;
            this.converted_human_leads_count = response.data.converted_human_leads_count;
            this.booked_leads_count = response.data.booked_leads_count;
            this.booked_ai_leads_count = response.data.booked_ai_leads_count;
            this.booked_human_leads_count = response.data.booked_human_leads_count;
            this.loading = false;

            if (this.$route.query.tconv) {
                // https://organic-train-7vqj4qq9x9hrgp5-8080.app.github.dev/login?alt=ZXlKMGVYQWlPaUpLVjFRaUxDSmhiR2NpT2lKSVV6STFOaUo5LmV5SnBjM01pT2lKb2RIUndjenBjTDF3dmJITmhMbkpoZG5VdWJXVmNMM1JqYjI1Mklpd2lhV0YwSWpveE56TXdORFkwT1RFeUxDSmxlSEFpT2pFM016RXdOamszTVRJc0ltNWlaaUk2TVRjek1EUTJORGt4TWl3aWFuUnBJam9pYW1WM1pHZE9Xa2htUmt0aWNVMHlUQ0lzSW5OMVlpSTZNVEF6TXl3aWNISjJJam9pTWpOaVpEVmpPRGswT1dZMk1EQmhaR0l6T1dVM01ERmpOREF3T0RjeVpHSTNZVFU1TnpabU55SjkueU5PbmtGUlFmaWZ6YlI2MzBmYlRhZ1Y0bHp5MW12QWtCNXpSNVlROHdoMA==&redirect=%2Fleads%3Ftconv%3D162368

                // this.showBlandRecording = showBlandRecordingFunction(item);

                tryClick();

                function tryClick() {
                    try {
                        console.log('trying...');
                        document.querySelector("#sblrcfncc-" + this.$route.query.tconv).click();
                    }
                    catch(e) {
                        setTimeout(function() {
                            tryClick();
                        }, 100);
                    }
                }
            }
        },

        async doCreated() {
            let self = this
            self.getMessages();
        }
    },

    destroyed() {
        clearTimeout(this.thisProc);
        this.thisProc = null;
    },

    created() {
        this.doCreated();
    },
}
</script>


<style scoped>
</style>